/**
 * Remove consecutive duplicate segments from a file path.
 * e.g. "src/src/App.tsx" → "src/App.tsx"
 *      "/src/src/lib/" → "/src/lib/"
 */
export function normalizePath(p: string): string {
  const segments = p.split('/');
  return segments.filter((seg, i) => i === 0 || seg !== segments[i - 1]).join('/');
}
